module.exports = __webpack_public_path__ + "static/media/girl-holding-device-dollars.4a032e94.svg";